/* Import Estilo */
import './index.scss';
import '../../../../css/global.css';
import '../../../../css/normalize.css';

/* Import Bibliotecas */
import { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/* Import Componentes */
import Cabecalho from '../../../../components/Cabecalho';
import Rodape from '../../../../components/Rodape';
import CookieAceite from '../../../../components/CookieAceite';
import MenuLateral from '../../../../components/MenuLateral';
import BtnVoltar from '../../../../components/bntVoltar';

/* Import Requisição API */
import api from '../../../../api';
import { useToast } from '../../../../context/ToastContext';
import { formatadorNumeroCelular } from '../../../../utils/Validadores';
import { formatarDescricaoLonga } from '../../../../utils/descricaoLonga';

export default function VisualizarProduto() {
    const location = useLocation();
    const id_produto = location.state?.id_produto;
    const navigate = useNavigate();

    const [produto, setProduto] = useState(null);

    const [imagensAtuais, setImagensAtuais] = useState({});

    const [idProdutoParaExcluir, setIdProdutoParaExcluir] = useState(null);
    const [processandoToggle, setProcessandoToggle] = useState(false);
    const [touchStartX, setTouchStartX] = useState(0);
    const [touchEndX, setTouchEndX] = useState(0);
    const { showToast } = useToast();
    const descricaoCurtaHtml = formatarDescricaoLonga(produto?.descricao || 'Sem descrição');
    const descricaoLongaHtml = formatarDescricaoLonga(produto?.descricao_longa || '');

//     /* ============ CENTRAL DE ESTÚDIO ============ */
//     const canvasRef = useRef(null);
//     const [showStudio, setShowStudio] = useState(false);
//     const [studioVarIndex, setStudioVarIndex] = useState(0);
//     const [studioFormat, setStudioFormat] = useState('feed');
//     const [studioElements, setStudioElements] = useState({
//         nome: true, precoVarejo: true, precoAtacado: false, descricao: false,
//         cor: true, tamanho: true, material: false, tipo: false,
//         quantidade: false, promocao: false, unidadesPacote: false, marca: false,
//     });
//     const [studioBg, setStudioBg] = useState('#ffffff');
//     const [studioTextColor, setStudioTextColor] = useState('#131C46');
//     const [studioAccentColor, setStudioAccentColor] = useState('#25d366');
//     const [studioPromoTexto, setStudioPromoTexto] = useState('PROMOÇÃO');
//     const [studioImgIdx, setStudioImgIdx] = useState(0);
// 
//     const toggleStudioElement = (key) => {
//         setStudioElements(prev => ({ ...prev, [key]: !prev[key] }));
//     };
// 
//     const renderStudioCanvas = useCallback(() => {
//         const canvas = canvasRef.current;
//         if (!canvas || !produto || !produto.variacoes?.length) return;
//         const v = produto.variacoes[studioVarIndex] || produto.variacoes[0];
//         if (!v) return;
// 
//         const ctx = canvas.getContext('2d');
//         const isFeed = studioFormat === 'feed';
//         const W = 1080;
//         const H = isFeed ? 1080 : 1920;
//         canvas.width = W;
//         canvas.height = H;
// 
//         ctx.fillStyle = studioBg;
//         ctx.fillRect(0, 0, W, H);
// 
//         /* Ondas estilo ComprovanteEstilizado (4 camadas, bezier) */
//         const sx = W / 1094;
//         const drawWaveBand = (pts, baseY, fillDown, color, alpha) => {
//             ctx.save(); ctx.globalAlpha = alpha; ctx.fillStyle = color;
//             ctx.beginPath();
//             ctx.moveTo(pts[0][0] * sx, pts[0][1]);
//             for (let i = 1; i < pts.length; i++) {
//                 const p = pts[i];
//                 if (p.length === 6) ctx.bezierCurveTo(p[0]*sx, p[1], p[2]*sx, p[3], p[4]*sx, p[5]);
//                 else ctx.lineTo(p[0]*sx, p[1]);
//             }
//             ctx.lineTo(fillDown ? W : 0, baseY);
//             ctx.lineTo(pts[0][0]*sx, baseY);
//             ctx.closePath(); ctx.fill(); ctx.restore();
//         };
//         /* --- ONDA TOPO --- */
//         const t1=[[1094,87.42],[1057.53,90.06],[1021.07,92.70,948.13,97.99,875.2,101.24],[802.27,104.50,729.33,105.71,656.4,103.68],[583.47,101.65,510.53,96.36,437.6,96.97],[364.67,97.58,291.73,104.09,218.8,107.42],[145.87,110.72,72.93,110.88,36.47,110.92],[0,111]];
//         const t2=[[1094,85.79],[1057.53,82.74],[1021.07,79.69,948.13,73.59,875.2,72.98],[802.27,72.37,729.33,77.25,656.4,81.24],[583.47,85.26,510.53,88.35,437.6,89.98],[364.67,91.61,291.73,91.77,218.8,91.36],[145.87,90.95,72.93,89.98,36.47,89.53],[0,89.04]];
//         const t3=[[1094,51.23],[1057.53,52.86],[1021.07,54.48,948.13,57.74,875.2,60.05],[802.27,62.33,729.33,63.71,656.4,62.53],[583.47,61.40,510.53,57.74,437.6,56.60],[364.67,55.42,291.73,56.80,218.8,59.69],[145.87,62.62,72.93,67.09,36.47,69.32],[0,71.56]];
//         const t4=[[1094,32.37],[1057.53,31.51],[1021.07,30.58,948.13,28.87,875.2,31.91],[802.27,35.01,729.33,42.94,656.4,46.90],[583.47,50.86,510.53,50.86,437.6,47.89],[364.67,44.92,291.73,38.97,218.8,34.02],[145.87,29.07,72.93,25.10,36.47,23.12],[0,21.14]];
//         drawWaveBand(t1, 0, false, '#ffffff', 0.25);
//         drawWaveBand(t2, 0, false, '#ACABBD', 0.5);
//         drawWaveBand(t3, 0, false, '#5F5F80', 0.75);
//         drawWaveBand(t4, 0, false, '#131C46', 1.0);
//         /* --- ONDA BASE --- */
//         const flip = (pts) => pts.map(p => p.length === 6 ? [p[0], H-p[1], p[2], H-p[3], p[4], H-p[5]] : [p[0], H-p[1]]);
//         drawWaveBand(flip(t1), H, true, '#ffffff', 0.25);
//         drawWaveBand(flip(t2), H, true, '#ACABBD', 0.5);
//         drawWaveBand(flip(t3), H, true, '#5F5F80', 0.75);
//         drawWaveBand(flip(t4), H, true, '#131C46', 1.0);
// 
//         const imgEl = new Image();
//         imgEl.crossOrigin = 'anonymous';
//         const imgUrl = v.imagens?.[studioImgIdx] || v.imagens?.[0] || '';
//         imgEl.src = imgUrl;
// 
//         const drawTexts = () => {
//             let textY = isFeed ? 600 : 900;
//             const leftPad = 60;
//             const maxTextWidth = W - leftPad * 2;
// 
//             if (studioElements.promocao) {
//                 ctx.save();
//                 const badgeText = studioPromoTexto || 'PROMOÇÃO';
//                 ctx.font = 'bold 36px Arial, sans-serif';
//                 const badgeW = ctx.measureText(badgeText).width + 40;
//                 ctx.fillStyle = '#ff0000';
//                 const r2 = 12, bx = leftPad, by = textY - 30;
//                 ctx.beginPath();
//                 ctx.moveTo(bx + r2, by); ctx.lineTo(bx + badgeW - r2, by);
//                 ctx.quadraticCurveTo(bx + badgeW, by, bx + badgeW, by + r2);
//                 ctx.lineTo(bx + badgeW, by + 50 - r2);
//                 ctx.quadraticCurveTo(bx + badgeW, by + 50, bx + badgeW - r2, by + 50);
//                 ctx.lineTo(bx + r2, by + 50);
//                 ctx.quadraticCurveTo(bx, by + 50, bx, by + 50 - r2);
//                 ctx.lineTo(bx, by + r2);
//                 ctx.quadraticCurveTo(bx, by, bx + r2, by);
//                 ctx.fill();
//                 ctx.fillStyle = '#fff'; ctx.fillText(badgeText, bx + 20, by + 36);
//                 ctx.restore(); textY += 40;
//             }
// 
//             if (studioElements.nome) {
//                 ctx.save(); ctx.font = 'bold 44px Arial, sans-serif'; ctx.fillStyle = studioTextColor;
//                 const nm = produto.nome || ''; const met = ctx.measureText(nm);
//                 const pW = Math.min(met.width + 50, maxTextWidth + 50), pH = 60, pX = leftPad, pY = textY - 8;
//                 ctx.strokeStyle = studioTextColor; ctx.lineWidth = 3;
//                 const r = pH / 2;
//                 ctx.beginPath(); ctx.moveTo(pX + r, pY); ctx.lineTo(pX + pW - r, pY);
//                 ctx.arc(pX + pW - r, pY + r, r, -Math.PI / 2, Math.PI / 2);
//                 ctx.lineTo(pX + r, pY + pH); ctx.arc(pX + r, pY + r, r, Math.PI / 2, -Math.PI / 2);
//                 ctx.stroke(); ctx.fillText(nm, pX + 25, pY + 44, maxTextWidth);
//                 ctx.restore(); textY += 80;
//             }
// 
//             if (studioElements.precoVarejo && v.preco_varejo) {
//                 ctx.save();
//                 const pt = `R$ ${Number(v.preco_varejo).toFixed(2).replace('.', ',')}`;
//                 ctx.font = 'bold 40px Arial, sans-serif'; ctx.fillStyle = studioTextColor;
//                 const pm2 = ctx.measureText(pt), ppW = pm2.width + 50, ppH = 56, ppX = leftPad, ppY = textY - 8;
//                 ctx.strokeStyle = studioTextColor; ctx.lineWidth = 3;
//                 const pr = ppH / 2;
//                 ctx.beginPath(); ctx.moveTo(ppX + pr, ppY); ctx.lineTo(ppX + ppW - pr, ppY);
//                 ctx.arc(ppX + ppW - pr, ppY + pr, pr, -Math.PI / 2, Math.PI / 2);
//                 ctx.lineTo(ppX + pr, ppY + ppH); ctx.arc(ppX + pr, ppY + pr, pr, Math.PI / 2, -Math.PI / 2);
//                 ctx.stroke(); ctx.fillText(pt, ppX + 25, ppY + 40);
//                 ctx.restore(); textY += 70;
//             }
// 
//             if (studioElements.precoAtacado && v.preco_atacado) {
//                 ctx.save();
//                 ctx.font = '32px Arial, sans-serif'; ctx.fillStyle = studioAccentColor;
//                 ctx.fillText(`Atacado: R$ ${Number(v.preco_atacado).toFixed(2).replace('.', ',')}`, leftPad + 25, textY + 30);
//                 ctx.restore(); textY += 50;
//             }
// 
//             const det = [];
//             if (studioElements.cor && v.cor) det.push(`Cor: ${v.cor}`);
//             if (studioElements.tamanho && v.tamanho) det.push(`Tam: ${v.tamanho}`);
//             if (studioElements.material && v.material) det.push(`Material: ${v.material}`);
//             if (studioElements.tipo && v.tipo) det.push(`Tipo: ${v.tipo}`);
//             if (studioElements.unidadesPacote && v.unidades_por_pacote) det.push(`${v.unidades_por_pacote} un/pacote`);
//             if (studioElements.quantidade && v.estoque) det.push(`Estoque: ${v.estoque}`);
//             if (studioElements.marca && produto.marca) det.push(`Marca: ${produto.marca}`);
//             if (det.length > 0) {
//                 ctx.save(); ctx.font = '28px Arial, sans-serif'; ctx.fillStyle = '#555';
//                 ctx.fillText(det.join('  •  '), leftPad + 25, textY + 26, maxTextWidth);
//                 ctx.restore(); textY += 45;
//             }
// 
//             if (studioElements.descricao && produto.descricao) {
//                 ctx.save(); ctx.font = '24px Arial, sans-serif'; ctx.fillStyle = '#666';
//                 const desc = produto.descricao.substring(0, 120) + (produto.descricao.length > 120 ? '...' : '');
//                 ctx.fillText(desc, leftPad + 25, textY + 24, maxTextWidth);
//                 ctx.restore();
//             }
//         };
// 
//         imgEl.onload = () => {
//             const maxImgH = isFeed ? H * 0.50 : H * 0.45;
//             const maxImgW = W * 0.85;
//             const imgRatio = imgEl.width / imgEl.height;
//             let drawW2, drawH2;
//             if (imgRatio > maxImgW / maxImgH) { drawW2 = maxImgW; drawH2 = maxImgW / imgRatio; }
//             else { drawH2 = maxImgH; drawW2 = maxImgH * imgRatio; }
//             const imgX = (W - drawW2) / 2;
//             const imgY = isFeed ? 140 : 200;
//             ctx.drawImage(imgEl, imgX, imgY, drawW2, drawH2);
//             drawTexts();
//         };
//         imgEl.onerror = () => drawTexts();
//     }, [produto, studioVarIndex, studioImgIdx, studioFormat, studioElements, studioBg, studioTextColor, studioAccentColor, studioPromoTexto]);
// 
//     useEffect(() => {
//         if (showStudio) {
//             const timer = setTimeout(renderStudioCanvas, 100);
//             return () => clearTimeout(timer);
//         }
//     }, [showStudio, renderStudioCanvas]);
// 
//     const downloadStudioImage = () => {
//         const canvas = canvasRef.current;
//         if (!canvas) return;
//         const link = document.createElement('a');
//         link.download = `${produto?.nome || 'produto'}-${studioFormat}.png`;
//         link.href = canvas.toDataURL('image/png');
//         link.click();
//     };
//     /* ============ FIM CENTRAL DE ESTÚDIO ============ */

    /* Dialog de exclusão de funcionário */
    const [modalAberto, setModalAberto] = useState(false);
    const caixaDeDialogo = useRef(null);

    useEffect(() => {
        caixaDeDialogo.current = document.getElementById("CaixaDeDialogo");
    }, []);

    const abrirModalExcluir = (id_produto) => {
        setIdProdutoParaExcluir(id_produto);
        if (caixaDeDialogo.current) {
            caixaDeDialogo.current.showModal();
        }
    };

    const fecharModal = () => {
        setModalAberto(false);
        caixaDeDialogo.current?.close();
        setIdProdutoParaExcluir(null);
    };

    const confirmarExcluirProduto = async () => {
        try {
            console.log('Excluindo produto com ID:', idProdutoParaExcluir);
            const res = await api.delete(`/produto/${idProdutoParaExcluir}`);
            if (res.data.success) {
                showToast('Ação concluída com sucesso!', 'success');
                navigate('/menu/produtos_e_estoque');
            } else {
                showToast('Ocorreu um erro ao realizar a ação!', 'error');
            }
            fecharModal();
        } catch (error) {
            console.error('Erro ao excluir produto:', error);
            fecharModal();
        }
    };

    useEffect(() => {
        if (!id_produto) return;
        async function carregarProduto() {
            try {
                const usuarioId = 1;
                const resposta = await api.get(`/produtoadm/${id_produto}`, {
                    params: { usuarioId }
                });

                if (resposta.data.success) {
                    console.log(resposta.data.produto)
                    setProduto(resposta.data.produto);
                } else {
                    console.error("Erro ao buscar produto:", resposta.data.message);
                }
            } catch (erro) {
                console.error('Erro ao buscar produto:', erro);
            }
        }
        carregarProduto();
    }, [id_produto]);

    const handleImageChange = (index, direction) => {
        setImagensAtuais((prev) => {
            const newImagensAtuais = { ...prev };
            const imagens = produto.variacoes[index].imagens;
            let newIndex = newImagensAtuais[index] || 0;
            newIndex = direction === 'next' ? (newIndex + 1) % imagens.length : (newIndex === 0 ? imagens.length - 1 : newIndex - 1);
            newImagensAtuais[index] = newIndex;
            return newImagensAtuais;
        });
    };
    const handleTouchStart = (e) => setTouchStartX(e.touches[0].clientX);
    const handleTouchMove = (e) => setTouchEndX(e.touches[0].clientX);
    const handleTouchEnd = (index) => {
        const swipeDistance = touchStartX - touchEndX;
        if (swipeDistance > 50) handleImageChange(index, 'next');
        else if (swipeDistance < -50) handleImageChange(index, 'prev');
    };

    const handleEdit = (id_produto) => {
        navigate(`/menu/produtos_e_estoque/editarproduto`, { state: { id_produto } });
    };

    const handleVerNoSite = (id_produto) => {
        window.open(`/produto/${id_produto}`, '_blank');
    };

    const handleDuplicar = (id_produto) => {
        navigate(`/menu/produtos_e_estoque/cadastrarproduto`, { state: { duplicarDe: id_produto } });
    };

    const calcularTotalEstoque = () => {
        if (!produto?.variacoes) return 0;
        return produto.variacoes.reduce((total, variacao) => total + (variacao.estoque || 0), 0);
    };

    const calcularValorTotalEstoque = () => {
        if (!produto?.variacoes) return 0;
        return produto.variacoes.reduce((total, variacao) => {
            return total + ((variacao.estoque || 0) * (variacao.preco_compra || 0));
        }, 0);
    };

    const calcularMargemLucro = (precoVenda, precoCompra) => {
        if (!precoCompra || precoCompra === 0) return 0;
        return (((precoVenda - precoCompra) / precoCompra) * 100).toFixed(2);
    };

    const formatarData = (data) => {
        if (!data) return 'N/A';
        return new Date(data).toLocaleDateString('pt-BR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const handleToggleProdutoStatus = async () => {
        if (processandoToggle) return;

        setProcessandoToggle(true);
        try {
            const novoStatus = produto.status === 'ativo' ? 'inativo' : 'ativo';
            const res = await api.put(`/produto/${produto.id_produto}`, {
                status: novoStatus
            });

            if (res.data.success) {
                setProduto({ ...produto, status: novoStatus });
                showToast(`Produto ${novoStatus === 'ativo' ? 'ativado' : 'desativado'} com sucesso!`, 'success');
            } else {
                showToast('Erro ao alterar status do produto', 'error');
            }
        } catch (error) {
            console.error('Erro ao alterar status:', error);
            showToast('Erro ao alterar status do produto', 'error');
        } finally {
            setProcessandoToggle(false);
        }
    };

    const handleToggleVariacaoStatus = async (idVariacao, statusAtual) => {
        if (processandoToggle) return;

        setProcessandoToggle(true);
        try {
            const novoStatus = statusAtual === 'ativo' ? 'inativo' : 'ativo';
            const res = await api.put(`/variacao/${idVariacao}/status`, {
                status: novoStatus
            });

            if (res.data.success) {
                const variacoesAtualizadas = produto.variacoes.map(v =>
                    v.id_variacao === idVariacao ? { ...v, status: novoStatus } : v
                );
                setProduto({ ...produto, variacoes: variacoesAtualizadas });
                showToast(`Variação ${novoStatus === 'ativo' ? 'ativada' : 'desativada'} com sucesso!`, 'success');
            } else {
                showToast('Erro ao alterar status da variação', 'error');
            }
        } catch (error) {
            console.error('Erro ao alterar status da variação:', error);
            showToast('Erro ao alterar status da variação', 'error');
        } finally {
            setProcessandoToggle(false);
        }
    };

    const copiarSKU = (sku) => {
        navigator.clipboard.writeText(sku);
        showToast('SKU copiado para área de transferência!', 'success');
    };

    const copiarCodigoBarras = () => {
        navigator.clipboard.writeText(produto.codigo_barras);
        showToast('Código de barras copiado!', 'success');
    };

    return (
        <section className='container-principal-visualizarProduto'>
            <dialog id="CaixaDeDialogo" className={modalAberto ? 'open' : ''}>
                <div className='conteudo-dialog'>
                    <div className="dialog-texto">
                        <p>Você deseja excluir esse produto?</p>
                        <div className='bnts-decisao'>
                            <button className="bnt-sim" onClick={confirmarExcluirProduto}>
                                Sim
                            </button>
                            <button className="bnt-nao" onClick={fecharModal}>
                                Não
                            </button>
                        </div>
                    </div>
                </div>
            </dialog>

            <Cabecalho />
            <CookieAceite />
            <main className='main-visualizarProduto'>
                <MenuLateral />
                <section className='conteudo-visualizarProduto'>
                    <div className='titulo-visualizarProduto'>
                        <h1><span>Produtos e Estoque</span> &gt; Visualizar Produto</h1>
                    </div>
                    <BtnVoltar />
                    <div className='detalhes-produto'>
                        <div className='conteudo-DescricaoProduto'>
                            <div className='cabecalho-DescricaoProdutoTitulo'>
                                <h2>Dados do Produto</h2>
                                <div className='toggle-status-produto'>
                                    <span>Status:</span>
                                    <label className='switch'>
                                        <input
                                            type='checkbox'
                                            checked={produto?.status === 'ativo'}
                                            onChange={handleToggleProdutoStatus}
                                            disabled={processandoToggle}
                                        />
                                        <span className='slider'></span>
                                    </label>
                                    <span className={produto?.status === 'ativo' ? 'status-text ativo' : 'status-text inativo'}>
                                        {produto?.status === 'ativo' ? 'Ativo' : 'Inativo'}
                                    </span>
                                </div>
                            </div>
                            <div className='dados-DescricaoProduto'>

                                <div className="dadoDuplo">
                                    <div className="dado">
                                        <strong>Nome:</strong>
                                        <p>{produto?.nome}</p>
                                    </div>
                                    <div className="dado">
                                        <strong className="titulo">Marca:</strong>
                                        <p>{produto?.marca}</p>
                                    </div>
                                    <div className="dado">
                                        <strong className="titulo">Código de Barras:</strong>
                                        <div className="campo-copiavel">
                                            <p>{produto?.codigo_barras || 'Não informado'}</p>
                                            {produto?.codigo_barras && (
                                                <button className="btn-copiar" onClick={copiarCodigoBarras}>
                                                    <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M13.3333 7.5V4.16667C13.3333 3.72464 13.1577 3.30072 12.8452 2.98816C12.5326 2.67559 12.1087 2.5 11.6667 2.5H4.16667C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667V11.6667C2.5 12.1087 2.67559 12.5326 2.98816 12.8452C3.30072 13.1577 3.72464 13.3333 4.16667 13.3333H7.5M8.33333 6.66667H15.8333C16.7538 6.66667 17.5 7.41286 17.5 8.33333V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H8.33333C7.41286 17.5 6.66667 16.7538 6.66667 15.8333V8.33333C6.66667 7.41286 7.41286 6.66667 8.33333 6.66667Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                <div className="dadoDuplo">
                                    <div className="dado">
                                        <strong className="titulo">Categoria:</strong>
                                        <p>{produto?.categoria_nome || 'Sem categoria'}</p>
                                    </div>
                                    <div className="dado">
                                        <strong className="titulo">Fornecedor:</strong>
                                        <p>{produto?.fornecedor_nome || 'Não informado'}</p>
                                    </div>
                                </div>

                                <div className="dadoDuplo">
                                    <div className="dado">
                                        <strong className="titulo">Telefone:</strong>
                                        <p>{formatadorNumeroCelular(produto?.fornecedor_telefone)}</p>
                                    </div>
                                    <div className="dado">
                                        <strong className="titulo">Email:</strong>
                                        <p>{produto?.fornecedor_email || 'Não informado'}</p>
                                    </div>
                                </div>

                                <div className="dadoDuplo">
                                    <div className="dado">
                                        <strong className="titulo">Cadastrado:</strong>
                                        <p>{formatarData(produto?.criado_em)}</p>
                                    </div>
                                    <div className="dado">
                                        <strong className="titulo">Atualizado:</strong>
                                        <p>{formatarData(produto?.atualizado_em)}</p>
                                    </div>
                                </div>

                                <div className="descricao-completa">
                                    <strong>Descrição Curta:</strong>
                                    <div className="descricao-formatada" dangerouslySetInnerHTML={{ __html: descricaoCurtaHtml }} />
                                    
                                    {produto?.descricao_longa && (
                                        <>
                                            <strong>Descrição Completa:</strong>
                                            <div className="descricao-longa">
                                                <div className="descricao-formatada" dangerouslySetInnerHTML={{ __html: descricaoLongaHtml }} />
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className='variacao-produto'>
                            <div className='conteudo-VariacaoProdutoTitulo'>
                                <h2>Variações:</h2>
                            </div>

                            <div className='dados-VariacaoProduto'>
                                {produto?.variacoes?.length > 0 ? (
                                    produto.variacoes.map((variacao, index) => {
                                        const imagemAtual = imagensAtuais[index] || 0;
                                        const margemVarejo = calcularMargemLucro(variacao.preco_varejo, variacao.preco_compra);
                                        const margemAtacado = calcularMargemLucro(variacao.preco_atacado, variacao.preco_compra);
                                        const valorTotalVariacao = (variacao.estoque || 0) * (variacao.preco_compra || 0);

                                        return (
                                            <div key={index} className='variacao-card'>
                                                <div className='variacao-card-header'>
                                                    <div className='header-left'>
                                                        <h3>Variação {index + 1}</h3>
                                                        <span className={variacao.status === 'ativo' ? 'badge-ativo' : 'badge-inativo'}>
                                                            {variacao.status === 'ativo' ? 'Ativo' : 'Inativo'}
                                                        </span>
                                                    </div>
                                                    <div className='header-right'>
                                                        <label className='switch-small'>
                                                            <input
                                                                type='checkbox'
                                                                checked={variacao.status === 'ativo'}
                                                                onChange={() => handleToggleVariacaoStatus(variacao.id_variacao, variacao.status)}
                                                                disabled={processandoToggle}
                                                            />
                                                            <span className='slider-small'></span>
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className='variacao-card-body'>
                                                    {/* Imagem */}
                                                    <div className='imagem-Variacao'>
                                                        {variacao.imagens?.length > 0 && (
                                                            <div className='carrossel-container'
                                                                onTouchStart={handleTouchStart}
                                                                onTouchMove={handleTouchMove}
                                                                onTouchEnd={() => handleTouchEnd(index)}>
                                                                <div className='containerImg-Button'>
                                                                    <button
                                                                        className="btn-carrossel"
                                                                        onClick={() => handleImageChange(index, 'prev')}
                                                                    >
                                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.6667 5.83317L7.5 9.99984L11.6667 14.1665" strokeWidth="2.08333" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                                    </button>
                                                                    <div className="carrossel-inner">
                                                                        <img
                                                                            className="d-block w-100"
                                                                            src={variacao.imagens[imagemAtual]}
                                                                            alt={`Imagem ${imagemAtual + 1}`}
                                                                        />
                                                                    </div>
                                                                    <button
                                                                        className="btn-carrossel"
                                                                        onClick={() => handleImageChange(index, 'next')}
                                                                    >
                                                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.33333 14.1668L12.5 10.0002L8.33333 5.8335" strokeWidth="2.08333" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                                                    </button>
                                                                </div>
                                                                <div className="indicador-bolinhas">
                                                                    {variacao.imagens.map((_, i) => (
                                                                        <span key={i} className={`dot ${imagemAtual === i ? "active" : ""}`}></span>
                                                                    ))}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>

                                                    {/* Descrição */}
                                                    <div className='descricao-Variacao'>
                                                        <div className="dadoDuplo">
                                                            <div className="dado">
                                                                <strong className="titulo">Tamanho:</strong>
                                                                <p>{variacao.tamanho}</p>
                                                            </div>
                                                            <div className="dado">
                                                                <strong className="titulo">Cor:</strong>
                                                                <p>{variacao.cor}</p>
                                                            </div>
                                                        </div>
                                                        <div className="dadoDuplo">
                                                            <div className="dado">
                                                                <strong className="titulo">Material:</strong>
                                                                <p>{variacao.material}</p>
                                                            </div>
                                                            <div className="dado">
                                                                <strong className="titulo">Tipo:</strong>
                                                                <p>{variacao.tipo || 'Não informado'}</p>
                                                            </div>
                                                        </div>
                                                        <div className="dadoDuplo">
                                                            <div className="dado">
                                                                <strong className="titulo">SKU:</strong>
                                                                <div className="campo-copiavel">
                                                                    <p>{variacao.sku || 'Não informado'}</p>
                                                                    {variacao.sku && (
                                                                        <button className="btn-copiar" onClick={() => copiarSKU(variacao.sku)}>
                                                                            <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path d="M13.3333 7.5V4.16667C13.3333 3.72464 13.1577 3.30072 12.8452 2.98816C12.5326 2.67559 12.1087 2.5 11.6667 2.5H4.16667C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667V11.6667C2.5 12.1087 2.67559 12.5326 2.98816 12.8452C3.30072 13.1577 3.72464 13.3333 4.16667 13.3333H7.5M8.33333 6.66667H15.8333C16.7538 6.66667 17.5 7.41286 17.5 8.33333V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H8.33333C7.41286 17.5 6.66667 16.7538 6.66667 15.8333V8.33333C6.66667 7.41286 7.41286 6.66667 8.33333 6.66667Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                                            </svg>
                                                                        </button>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="dado">
                                                                <strong className="titulo">Un./Pacote:</strong>
                                                                <p>{variacao.unidades_por_pacote || 'Não informado'}</p>
                                                            </div>
                                                        </div>
                                                        <div className="dadoDuplo">
                                                            <div className="dado">
                                                                <strong className="titulo">Estoque:</strong>
                                                                <p>{variacao.estoque} unidades</p>
                                                            </div>
                                                            <div className="dado">
                                                                <strong className="titulo">Peso:</strong>
                                                                <p>{variacao.peso ? `${variacao.peso} kg` : 'Não informado'}</p>
                                                            </div>
                                                        </div>
                                                        <div className="dadoDuplo">
                                                            <div className="dado">
                                                                <strong className="titulo">Preço Compra:</strong>
                                                                <p>R$ {Number(variacao.preco_compra).toFixed(2)}</p>
                                                            </div>
                                                            <div className="dado">
                                                                <strong className="titulo">Preço Varejo:</strong>
                                                                <p>R$ {Number(variacao.preco_varejo).toFixed(2)} <span className="margem-lucro">({margemVarejo > 0 ? '+' : ''}{margemVarejo}%)</span></p>
                                                            </div>
                                                            <div className="dado">
                                                                <strong className="titulo">Preço Atacado:</strong>
                                                                <p>R$ {Number(variacao.preco_atacado).toFixed(2)} <span className="margem-lucro">({margemAtacado > 0 ? '+' : ''}{margemAtacado}%)</span></p>
                                                            </div>
                                                        </div>
                                                        <div className="dadoDuplo">
                                                            <div className="dado">
                                                                <strong className="titulo">Dimensões:</strong>
                                                                <p>{variacao.altura && variacao.largura && variacao.profundidade
                                                                    ? `${variacao.altura} x ${variacao.largura} x ${variacao.profundidade} cm`
                                                                    : 'Não informado'}</p>
                                                            </div>
                                                            <div className="dado">
                                                                <strong className="titulo">Valor Total:</strong>
                                                                <p>R$ {valorTotalVariacao.toFixed(2)}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })
                                ) : (
                                    <p>Sem variações disponíveis.</p>
                                )}
                            </div>
                        </div>

                        <div className='conteudo-EstatisticasProduto'>
                            <div className='cabecalho-EstatisticasProdutoTitulo'>
                                <h2>Estatísticas do Produto</h2>
                            </div>
                            <div className='dados-EstatisticasProduto'>
                                <div className="dadoDuplo">
                                    <div className="dado">
                                        <strong className="titulo">Estoque Total:</strong>
                                        <p>{calcularTotalEstoque()} unidades</p>
                                    </div>
                                    <div className="dado">
                                        <strong className="titulo">Valor Estoque:</strong>
                                        <p>R$ {calcularValorTotalEstoque().toFixed(2)}</p>
                                    </div>
                                    <div className="dado">
                                        <strong className="titulo">Variações:</strong>
                                        <p>{produto?.variacoes?.length || 0}</p>
                                    </div>
                                </div>
                                <div className="dadoDuplo">
                                    <div className="dado">
                                        <strong className="titulo">Total Vendas:</strong>
                                        <p>{produto?.total_vendido || 0} unidades</p>
                                    </div>
                                    <div className="dado">
                                        <strong className="titulo">Pedidos:</strong>
                                        <p>{produto?.total_pedidos || 0}</p>
                                    </div>
                                    <div className="dado">
                                        <strong className="titulo">Última Venda:</strong>
                                        <p>{produto?.ultima_venda ? formatarData(produto.ultima_venda) : 'Nenhuma venda'}</p>
                                    </div>
                                </div>
                                <div className="dadoDuplo">
                                    <div className="dado">
                                        <strong className="titulo">Avaliação:</strong>
                                        <p className="avaliacao-media">⭐ {produto?.media_avaliacao || '0.0'}</p>
                                    </div>
                                    <div className="dado">
                                        <strong className="titulo">Avaliações:</strong>
                                        <p>{produto?.total_avaliacoes || 0}</p>
                                    </div>
                                    <div className="dado">
                                        <strong className="titulo">Status:</strong>
                                        <p className={produto?.status === 'ativo' ? 'status-disponivel' : 'status-esgotado'}>
                                            {produto?.status === 'ativo' ? 'Ativo' : 'Inativo'}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='bnts-produtos'>
                        <button className='bnt-ver-site' onClick={() => handleVerNoSite(produto.id_produto)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /><path d="M17.5 10C15.4167 13.75 13.0833 15.625 10 15.625C6.91667 15.625 4.58333 13.75 2.5 10C4.58333 6.25 6.91667 4.375 10 4.375C13.0833 4.375 15.4167 6.25 17.5 10Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>Ver no Site</button>
                        <button className='bnt-duplicar' onClick={() => handleDuplicar(produto.id_produto)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.3333 7.5V4.16667C13.3333 3.72464 13.1577 3.30072 12.8452 2.98816C12.5326 2.67559 12.1087 2.5 11.6667 2.5H4.16667C3.72464 2.5 3.30072 2.67559 2.98816 2.98816C2.67559 3.30072 2.5 3.72464 2.5 4.16667V11.6667C2.5 12.1087 2.67559 12.5326 2.98816 12.8452C3.30072 13.1577 3.72464 13.3333 4.16667 13.3333H7.5M8.33333 6.66667H15.8333C16.7538 6.66667 17.5 7.41286 17.5 8.33333V15.8333C17.5 16.7538 16.7538 17.5 15.8333 17.5H8.33333C7.41286 17.5 6.66667 16.7538 6.66667 15.8333V8.33333C6.66667 7.41286 7.41286 6.66667 8.33333 6.66667Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" /></svg>Duplicar</button>
                        <button className='bnt-editar' onClick={() => handleEdit(produto.id_produto)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M12.4999 5.00007L14.9999 7.50007M10.8333 16.6667H17.4999M4.16659 13.3334L3.33325 16.6667L6.66659 15.8334L16.3216 6.17841C16.634 5.86586 16.8096 5.44201 16.8096 5.00007C16.8096 4.55813 16.634 4.13429 16.3216 3.82174L16.1783 3.67841C15.8657 3.36596 15.4419 3.19043 14.9999 3.19043C14.558 3.19043 14.1341 3.36596 13.8216 3.67841L4.16659 13.3334Z" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" /></svg>Editar Produto</button>
                        <button className='bnt-excluir' onClick={() => abrirModalExcluir(produto.id_produto)}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M11.6666 9.16667V14.1667M8.33325 9.16667V14.1667M4.99992 5.83333V15.8333C4.99992 16.2754 5.17551 16.6993 5.48807 17.0118C5.80063 17.3244 6.22456 17.5 6.66659 17.5H13.3333C13.7753 17.5 14.1992 17.3244 14.5118 17.0118C14.8243 16.6993 14.9999 16.2754 14.9999 15.8333V5.83333M3.33325 5.83333H16.6666M5.83325 5.83333L7.49992 2.5H12.4999L14.1666 5.83333" stroke-width="2.08333" stroke-linecap="round" stroke-linejoin="round" /></svg>Excluir Produto</button>
                    </div>
                </section>
            </main>
            <Rodape />
        </section>
    );
}
